<template>
  <asc-header
    :value="value"
    size="h3"
    :no-margins="noMargins"
    :uppercase="uppercase"
    :color="color"
  ></asc-header>
</template>

<script>
import AscHeader from './AscHeader'

export default {
  name: 'AscSubtitle',

  components: {
    AscHeader,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    noMargins: {
      type: Boolean,
      default: true,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },
}
</script>
